module.exports = __webpack_public_path__ + "static/media/lupaWhite.e18b1131.svg";